export default "__VITE_ASSET__DnJulCMB__"